import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ColDef, CellStyle, ExcelExportParams, GridReadyEvent, ISetFilterParams, themeQuartz, ValueFormatterParams } from 'ag-grid-community';  
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { Component, Inject, OnInit,ChangeDetectorRef } from '@angular/core';
import { formatText } from 'src/app/shared/commen-function-file';
import { CommentDialogComponent } from 'src/app/shared/comment-dialog/comment-dialog.component';
interface AssetNode {
  id: any;
  assetName: string;
  children?: AssetNode[];
}
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY'
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}




@Component({
  selector: 'app-newasset',
  templateUrl: './newasset.component.html',
  styleUrls: ['./newasset.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})

export class NewassetComponent  implements OnInit {
  buttonColorName: any;
  updateData: any;
  userListDataForAsset: any;
  dropdownSettingsForBand: IDropdownSettings = {};
  dropdownSettingsForAsset: IDropdownSettings = {};
  dropdownSettingsForEmployee: IDropdownSettings = {};
  selectedEmployeeIdForReport: any;
  dropdownDataForAsset: any;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserId: any | null;
  year: any;
  fiscalYear: any;
  oprationMethod: any;
  todayDate: any;
  datedisplay: any
  userAssetDisable: any;
  deselectBand: any;
  selectedEmployeeIds: any;
  arrOriginalAssets: any =[];
  arrBandsForAssets: any ={};
  formatedataVariable = formatText;
  arrAllocatingDept: any;
  loggedInUserRole: any;
  findLogdinUserAsaAuthority: any = false;
  
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private encryptionService: EncryptionService, public dialog: MatDialog,private toastr: ToastrService,
    private config: Config, private httpService: HttpService, private datePipe: DatePipe,private cdRef: ChangeDetectorRef,public dialogRef: MatDialogRef<NewassetComponent>) {


    this.todayDate = new Date().toISOString().split('T')[0];
    this.datedisplay = this.todayDate
    this.oprationMethod = data.operation
    this.year = data?.year;
    this.fiscalYear = data?.fiscal_year;
    this.updateData = data?.data;
    this.userAssetDisable = data?.userAssetDisable;
    this.findLogdinUserAsaAuthority = data?.findLogdinUserAsaAuthority; 
    if (this.updateData != null) {

      // this.selectedEmployee = this.updateData.users.map((elm: any) => elm.userId);
      this.selectedAsset = this.updateData.users.map((elm: any) => elm.assetId);
      this.selectedAsset = this.selectedAsset[0];

    }


  }
  assetOptions: string[] = [
    'ASSET_GIVEN',
   
  ];


  ngOnInit() {

    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');

    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
     if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.assetAllocationData();
    this.getAllaseetListingData();
    this.getAllEmployeeRecord();
    this.assetAllocateEmployees();
    this.allocateEmployees()
    // this.allAssets = this.userListDataForAsset.users.map((asset: { assetName: any; }) => asset.assetName);

    this.dropdownSettingsForBand = {
      singleSelection: false,
      idField: 'id',
      textField: 'itemName',
      // disabledField: 'disabled',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,

    };

    
  
    this.dropdownSettingsForAsset = {
      singleSelection: true,
      idField: 'assetId',
      textField: 'assetName',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 1,
      allowSearchFilter: false,
    };



    this.dropdownSettingsForEmployee = {
      singleSelection: false, 
      idField: 'id',      
      textField: 'itemName', 
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
   
    this.buildColumnDefs();
  }


  selectedAsset: any;
  selectedEmployee: any[]=[];
  selectedSubAsset: any;
  filteredEmployees: any[] = [];
  filteredAssets: any[] = [];
  selectedBand: any[] = [];
  // selectedAssets:any;
  getupdateBandData: any = [];
  //   // This function will be triggered when the asset (band) changes


// =========================Asset Dropdown==================================================

  selectedAssets: any[] = [];

  allAssets: string[] = []; // Holds all asset names to handle "Select All"





// ================================Onchahnge Asset===============================================






  // --------------------------------AG GRID CODE---------------------------------------------------------
  gridApi: any;
  paginationPageSizeSelector = [5, 10, 20, 50, 100, 200, 500, 1000];
  pagination = true;
  paginationPageSize = 10;
  detailRowAutoHeight = true;

  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 100,
    filter: true,
    resizable: true,
    sortable: true,
    floatingFilter: false,  // ✅ small filter box under header
  };

  gridOptions: any = {
    defaultColDef: {
      resizable: true,    // ✅ columns resize ho sakte hain
      sortable: true,  // ✅ sorting enable
      filter: true,  // ✅ filtering enable
      floatingFilter: true, // ✅ filters ki input box top me
      minWidth: 80,
      // ✅ rowIndex ke base pe alternate row styling (zebra effect)
      cellClass: (p: any) =>
        p.node.rowIndex % 2 === 0 ? 'cell-even' : 'cell-odd'
    },
    context: { componentParent: this },  // ✅ agar component method call karna ho renderer/formatter se
    rowSelection: 'single',     // ✅ single row select
    singleClickEdit: true,       // ✅ click = edit (Pending wale case me helpful)
    stopEditingWhenCellsLoseFocus: true,    // ✅ focus lose hote hi editing stop
    // ✅ jab bhi cell update hoga, ye call hoga
    // onCellValueChanged: (event: any) => this.onCellValueChanged(event)
    localeText: {
      noRowsToShow: 'No Data Found'  // default text ko replace karna hai 'No Rows To Show' to 'No Data Found'
    }
  };

  onCellValueChanged(event: any) {
    console.log("--------calue--", event.colDef.field)

    console.log('Cell value changed:', event.data);
  }
 



  openCommentModal(text: string, commentType: any) {
    this.dialog.open(CommentDialogComponent, {
      width: '600px',
      data: {
        text: text,
        commentType: commentType
      }
    });

  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
    console.log(params)
  }
  formatStatus(value: any): string {
    if (!value || typeof value !== 'string') {
      return 'N/A'; // fallback agar value string na ho
    }

    // Camel Case → Title Case
    return value
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  formatDate(value: any): string {
    if (!value) return 'N/A';

    const date = new Date(value);
    if (isNaN(date.getTime())) return 'Invalid Date';

    // dd-MM-yyyy format
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  // ✅ Global search function
  onFilterTextBoxChanged(value: string = '') {
    if (!this.gridApi) return;

    // v31+ way:
    this.gridApi.setGridOption('quickFilterText', value ?? '');

  }
  onBtExport() {
    const params: ExcelExportParams = {
      fileName: 'Expense_Report_' + new Date().toISOString().slice(0, 10) + '.xlsx',
      sheetName: 'ExpenseData',
      exportAsExcelTable: {
        showRowStripes: true,
        name: 'ExpenseTable'
      },
      processCellCallback: (cell) => {
        const header = cell.column.getColDef().headerName;
        const value = cell.value;

        // 1. Date Formatting (for specific headers)
        const dateColumns = ['date', 'dateOfExpense']; // <- field names ya headerName use karo

        if (dateColumns.includes(cell.column.getColId()) && cell.value) {
          const date = new Date(cell.value);
          if (!isNaN(date.getTime())) {
            return (
              ('0' + date.getDate()).slice(-2) +
              '-' +
              ('0' + (date.getMonth() + 1)).slice(-2) +
              '-' +
              date.getFullYear()
            );
          }
        }

        // 2. Status Formatting (make it human readable)
        if (header === 'Status' && value) {
          return value
            .toString()
            .toLowerCase()
            .replace(/_/g, ' ') // replace underscores with space
            .replace(/\b\w/g, (char: any) => char.toUpperCase()); // capitalize each word
        }

        return value;
      }
    };

    this.gridApi.exportDataAsExcel(params);
  }


  approvalRenderer(params: any) {
    if (!params.value) return '';
    const status = params.value.toUpperCase();

    let color = '';
    if (status === 'APPROVED') {
      color = '#4caf50'; // green
    } else if (status === 'REJECTED') {
      color = '#f44336'; // red
    } else if (status === 'PENDING') {
      color = '#ff9800'; // orange
    }

    return `
          <span style="
            border: 1px solid ${color};
            color: ${color};
            padding: 4px 10px;
            border-radius: 12px;
            font-size: 12px;
            font-weight: 500;
            display: inline-block;
            line-height: 20px;
            white-space: nowrap;
          ">
        ${status.charAt(0) + status.slice(1).toLowerCase()}
      </span>
    `;
  }

 


  

  statusFormatter(params: any): string {
    if (!params.value) return '';

    const valueUpper = params.value.toUpperCase();

    // 🔹 Status → Color map
    const statusColors: Record<string, string> = {
      'APPROVED_BY_FINANCE_BUT_NOT_PAID': '#4caf50', // green
      'APPROVED_BY_MANAGER_SENT_TO_FINANCE': '#4caf50',
      'APPROVED_BY_MANAGER_REJECTED_BY_FINANCE': '#f44336', // red
      'APPROVED_BY_HR_ADMIN_SENT_TO_FINANCE':'#126d79',
      'APPROVED_BY_MANAGER_SENT_TO_HR_ADMIN':'#3939ece8',
      'REJECTED_BY_MANAGER': '#f44336',
      'PENDING_WITH_MANAGER': '#ff9800', // orange
      'REJECTED_BY_HR_ADMIN':'#f44336'
    };

    // 🔹 Default color = grey
    const color =
      Object.keys(statusColors).find(key => valueUpper.includes(key))
        ? statusColors[
        Object.keys(statusColors).find(key => valueUpper.includes(key))!
        ]
        : '#999';

    // 🔹 Convert to Title Case
    const formattedText = params.value
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    return `
      <span style="
        border: 1px solid ${color};
        color: ${color};
        padding: 4px 10px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;
        display: inline-block;
        white-space: normal;
        word-wrap: break-word;
        line-height: 1.4em;
        animation: fadeInScale 0.3s ease-in-out;
        max-width: 100%;
      ">
        ${formattedText}
      </span>
    `;
  }

  dateRenderer(params: any) {
    if (!params.value) return '';
    const date = new Date(params.value);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  dateComparator(valueA: string, valueB: string) {
    const parseDate = (value: string) => {
      if (!value) return null;
      // Agar backend se yyyy-mm-dd aa raha hai:
      if (value.includes('-') && value.indexOf('-') === 4) {
        return new Date(value).getTime();
      }
      // Agar already dd-mm-yyyy format hai:
      const [day, month, year] = value.split('-').map(Number);
      return new Date(year, month - 1, day).getTime();
    };

    const dateA = parseDate(valueA);
    const dateB = parseDate(valueB);

    if (dateA === dateB) return 0;
    if (dateA == null) return -1;
    if (dateB == null) return 1;
    return dateA - dateB;
  }

  openFile(fileUrl: string) {
    window.open(fileUrl, '_blank');
  }
  downloadRenderer = (params: any) => {

    const fileUrl = `${this.config.downloadFile}${params.value}`;
    if (!params.value) return '';
    const img = document.createElement('img');
    img.src = 'assets/icon/yellowdownload.png'; // replace with your icon path
    img.alt = 'download';
    img.style.width = '18px';
    img.style.height = '18px';
    img.style.cursor = 'pointer';
    img.title = params.value;
    img.addEventListener('click', (e) => {
      e.stopPropagation();
      // open file in new tab
      window.open(fileUrl, '_blank');
    });
    return img;
  }

  downloadDialogRenderer(fileName: string): string {
    if (!fileName) return '';
    return `${this.config.downloadFile}${fileName}`;
  }
  selectedRow: any;
  isDetailsOpen = false;
  onRowClicked(event: any) {
     console.log('HR Admin Row Clicked:', event.data);
    this.selectedRow = event.data;
    console.log("selected row iss333...", this.selectedRow )
    //  this.isDetailsOpen = true;
  }
// For HR Admin
selectedRowForHrAdmin:any;

onRowClickedForHRAdmin(event: any) {
  console.log('HR row click -> data:', event.data);
  this.selectedRowForHrAdmin = event.data;
  // You can decide whether show detail on row click or only on cell click
   this.isDetailsOpenForHRAdmin = true;
}


  //Employe Login 
  onRowClickedForEmployee(event: any) {
    console.log('Clicked Column:**', event.colDef);
    this.selectedRow = event.data;
    if (event.colDef?.field === 'action') {
      this.isDetailsOpen = false;
    } else {
      this.isDetailsOpen = true;
    }
  }
  onCelledClicked(event: any) {
    console.log("field is..............",event);
    
    this.selectedRow = event.data;
    console.log("selected row iss...", this.selectedRow )
    // sirf managerComment ya approvedByManager pe hi details open kare
    if (event.colDef?.field === 'managerComment' || event.colDef?.field === 'approvedByManager'  || event.colDef?.field === 'approvedByHrAdmin') {
      this.isDetailsOpen = false;
    } else {
      this.isDetailsOpen = true;
      this.cdRef.detectChanges();
    }
  }
//For Hr Admin
isDetailsOpenForHRAdmin = false;
onCelledClickedForHRAdmin(event: any) {
  console.log('HR cellClicked field:', event.colDef?.field, 'data:', event.data);
  this.selectedRowForHrAdmin = event.data;

  // If you want to avoid opening for certain fields (mirrors your existing logic)
  if (event.colDef?.field === 'approvedByHrAdmin') {
    this.isDetailsOpenForHRAdmin = false;
  } else {
    this.isDetailsOpenForHRAdmin = true;
    this.cdRef.detectChanges();
  }
}

closeDetailsForHrAdmin() {
  this.isDetailsOpenForHRAdmin = false;
}
  // For Finance Login
  onCelledFinanceClicked(event: any) {

    this.selectedRow = event.data;

    // sirf financeComment ya assignedAmount pe hi details open kare
    if (event.colDef?.field === 'financeComment' || event.colDef?.field === 'assignedAmount' || event.colDef?.field === 'financeStatus') {
      this.isDetailsOpen = false;
    } else {
      this.isDetailsOpen = true;
    }
  }
  closeDetails() {
    this.isDetailsOpen = false;
  }

  isClicked = false;


  resetGrid() {
    this.isClicked = true; // Trigger animation

    if (this.gridApi) {
            
      // ✅ Reset filters & sorting
      this.gridApi.setFilterModel(null);
      // this.gridApi.setSortModel(null);
      this.gridApi.deselectAll();

      // ✅ Reset quick filter (search box)
      
      this.gridApi.setGridOption('quickFilterText', ''); // Clears quick filter text

      // ✅ Reset pagination
      this.paginationPageSize = 10;
      this.gridApi.setGridOption('paginationPageSize', this.paginationPageSize);
      this.gridApi.paginationGoToFirstPage();

      // ✅ Force refresh so UI input also clears
      this.gridApi.refreshCells();
      this.gridApi.resetColumnState();         // ✅ Reset columns
    }
  }


  // --------------------------------AG GRID CODE---------------------------------------------------------


 columnDefs: ColDef[] = [];
  buildColumnDefs() {
     
  this.columnDefs = [
  {
    headerName: 'Asset',
    field: 'assetName',
    minWidth: 150
  },
  {
    headerName: 'Employee Name',
    field: 'employeeName',
    minWidth: 180
  },
  {
    headerName: 'Band',
    field: 'band',
    minWidth: 120
  },
  {
    headerName: 'Allocating Dept',
    field: 'allocatingAuthorityDept',
    minWidth: 180
  },
  {
    headerName: 'Authority Name',
    field: 'allocatingAuthorityName',
    minWidth: 180
  },
  {
    headerName: 'Allocation Date',
    field: 'dateOfAllocation',
    minWidth: 180,
    editable: false,
    cellRenderer: (params: any) => this.dateRenderer(params),
    comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
    filter: 'agDateColumnFilter',
    wrapHeaderText: true,
    autoHeaderHeight: true,
    filterParams: {
      filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
      suppressAndOrCondition: true,  // ✅ AND/OR hide
      maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
    }
  },
 {
  headerName: 'Current Asset Description',
  field: 'currentAssetDescription',
  cellEditor: 'agLargeTextCellEditor',
  cellEditorParams: { maxLength: 255, rows: 3, cols: 30 },
  minWidth: 300,

  // ✏️ Editable logic
  editable: (params: any) => {
    const role = params.context.componentParent.loggedInUserRole;
    const selectedTab = params.context.componentParent.selectedTab;

    // 🔒 Disable if Employee, HR Admin, Super Admin, or Asset tab
    if (
      role === 'employee' ||
      role === 'HR Admin' ||
      role === 'Super Admin' ||
      selectedTab === 'Asset'
    ) {
      return false;
    }
    return true;
  },
  cellStyle: (params): CellStyle => {
    const role = params.context.componentParent.loggedInUserRole;
    const isAuth = params.context.componentParent.findLogdinUserAsaAuthority;
    const selectedTab = params.context.componentParent.selectedTab;

    const editable =
      !(
          role === 'employee' ||
      role === 'HR Admin' ||
      role === 'Super Admin' ||
      selectedTab === 'Asset'
      );

    // Return style object
    if (editable) {
      return {
        backgroundColor: '#e8f5e9',
        fontWeight: '600',
        color: '#0a0a0a'
      };
    } else {
      return {
        backgroundColor: '#fffffff',
        color: '#000000'
      };
    }
  }
   
 
}

 
  ,
  {
  headerName: 'HR ADMIN/Allocating Authority Comment',
  field: 'employeeAssetStatus',
    minWidth: 300, 
},
  {
    headerName: 'Authority Comment Date',
    field: 'authorityCommentDate',
    minWidth: 300,
    editable: false,
    cellRenderer: (params: any) => this.dateRenderer(params),
    comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
    filter: 'agDateColumnFilter',
    wrapHeaderText: true,
    autoHeaderHeight: true,
    filterParams: {
      filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
      suppressAndOrCondition: true,  // ✅ AND/OR hide
      maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
    }
    
  }
];

  }

















dropDownForband: any[] = [];
dropDownForEmployee: any[] = [];

onAssetChange1(selectedId: string | number | any) {
  // const selectedId = Id.assetId;
  // console.log(selectedId)
  this.selectedBand=[];
  this.selectedEmployee=[];

  
// Check if the selectedId exists in arrBandsForAssets and store the result
let matchedBands = this.arrBandsForAssets[selectedId];
 

// Check if matchedBands is not undefined
if (matchedBands) {
    // Store the matched bands into a new variable
    let newVariable = matchedBands;
    this.dropDownForband =  newVariable.map((band:any) => ({
      id: band,
      itemName: band,
      
    }));
    
} else {
    console.log("No bands found for the selected asset");
} 
}

onAssetChange11(selectedId: string | number) {
  this.selectedAsset = selectedId;
  this.selectedBand = [];
  this.selectedEmployee = [];

  this.filterAssetsBySelectedAsset();

  // Get unique bands for the selected asset
  const bandsSet = new Set(
    this.filteredAssets
      .map((item: any) => item.band)
      .filter(Boolean)
  );


  // Map unique bands to dropdown data
  this.dropDownForband = Array.from(bandsSet).map((band) => ({
    id: band,
    itemName: band,
  }));

  // Get unique employees based on the selected asset
  const employeeSet = new Set(
    this.filteredAssets
      .filter((item: any) => item.assetId === this.selectedAsset) // Filter employees based on the selected asset
      .map((item: any) => item.employeeName)
      .filter(Boolean)
  );
  // Map unique employees to dropdown data
  this.dropDownForEmployee = Array.from(employeeSet).map((employeeName) => ({
    id: employeeName,
    itemName: employeeName,
  }));
  
  
}

originalAssets: any[] = [];
assetAllocationData() {
  this.httpService
    .callGetService(`${this.config.assetAllocation}/${this.loggedInUserCompanyID}/${this.fiscalYear}/${this.year}`)
    .subscribe((response: any) => {
     
    });
}
filterAssetsBySelectedAsset() {
  if (!this.selectedAsset) {
    this.filteredAssets = this.originalAssets;
  } else {
    this.filteredAssets = this.originalAssets.filter(item => item.assetId === this.selectedAsset);
  }
}

  // ==================================Band Dropdown==========================================

  onSelectSingleSelectFilter: any;

 
  

  onSelectBand(event: any) {
    const band = this.selectedBand.map((elm: any) => elm.id); 
    const today = new Date().toISOString().split('T')[0];
    const year = this.year.split('-')[0];
  
    const formData = {
      companyId: this.loggedInUserCompanyID,
      bands: band,
      from: today,
      to: today,
      fromYear: year,
      toYear: year,
    };
 
    this.httpService
      .callGetService(`${this.config.assetAllocation}/${this.loggedInUserCompanyID}/${this.fiscalYear}/${this.year}`)
      .subscribe((response: any) => {
        const allocatedUserIds = (response?.data || []).map((item: any) => item.userId);
        console.log("Allocated User IDs...", allocatedUserIds);

        // Call the band-related API
        this.httpService
          .callPostService(`${this.config.getAllEmployeeListAgainstBand}`, formData)
          .subscribe((elm: any) => {
            const employees = elm.data || [];
            console.log("employees11...",employees)
            const filteredEmployees = employees.filter((emp: any) => !allocatedUserIds.includes(emp.userId));
            console.log("filtered employees22...", filteredEmployees)
            const arrFilteredEmployees = (this.findLogdinUserAsaAuthority) ? filteredEmployees.filter((record: any) => record.userId != this.loggedInUserId) :filteredEmployees;
            console.log("ArrFilteredEmployee33...",arrFilteredEmployees)
            // Populate the dropdown
            this.dropDownForEmployee = arrFilteredEmployees.map((emp: any) => ({
              id: emp.userId,
              itemName: `${emp.firstName.trim()} ${emp.lastName.trim()}`,
              band:emp.band
            }));
          
            console.log("Dropdown Employee44...", this.dropDownForEmployee);
            
          });
      });
  }
  



  
  onDeselectBand(event: any) {
    const deselectedBandId = event.id;
  
    this.dropDownForEmployee = this.dropDownForEmployee.filter(
      (emp: any) => emp.band !== deselectedBandId
    );
  
  
    this.arrOriginalAssets = this.arrOriginalAssets.filter(
      (asset: any) => {
        const emp = this.dropDownForEmployee.find((e: any) => e.id === asset.userId);
        return !!emp; 
      }
    );
  
   
    this.allocatedAssetsList = this.arrOriginalAssets;
  
   
    this.selectedEmployee = this.selectedEmployee.filter(
      (emp: any) => emp.band !== deselectedBandId
    );
    this.selectedEmployee=[]
  }

  
  
  selectAllBand(event: any) {
    const selectedBands = event.map((elm: any) => elm.id); // Get selected band IDs from event
    const today = new Date().toISOString().split('T')[0];
    const year = this.year.split('-')[0];
  
    if (!selectedBands.length) {
      this.dropDownForEmployee = []; // Clear if no band is selected
      return;
    }
  
    const formData = {
      companyId: this.loggedInUserCompanyID,
      bands: selectedBands,
      from: today,
      to: today,
      fromYear: year,
      toYear: year,
    };
  
    this.httpService
      .callGetService(`${this.config.assetAllocation}/${this.loggedInUserCompanyID}/${this.fiscalYear}/${this.year}`)
      .subscribe((response: any) => {
        const allocatedUserIds = (response?.data || []).map((item: any) => item.userId);
        
          
        this.httpService
          .callPostService(`${this.config.getAllEmployeeListAgainstBand}`, formData)
          .subscribe((elm: any) => {
            const employees = elm.data || [];
  
            const filteredEmployees = employees.filter(
              (emp: any) => !allocatedUserIds.includes(emp.userId)
            );
            console.log("11111111",filteredEmployees);
            
            //Remove the user when its authority and loggedinuser same
            const arrFilteredEmployees = (this.findLogdinUserAsaAuthority) ? filteredEmployees.filter((record: any) => record.userId != this.loggedInUserId) :filteredEmployees;
            console.log("2222222..........",arrFilteredEmployees);
            
            this.dropDownForEmployee = arrFilteredEmployees.map((emp: any) => ({
              id: emp.userId,
              itemName: `${emp.firstName.trim()} ${emp.lastName.trim()}`,
              band: emp.band,
            }));
          });
      });
  }
  
  
  onDeSelectAllBand(event: any) {
    
    this.arrOriginalAssets = [];
    this.allocatedAssetsList = [];
    this.dropDownForEmployee = [];
  }
  
  
  
  
//  ========================Employee dropdown==========================
private addEmployeeToAssetList(empId: any): void {
  const emp = this.dropDownForEmployee.find((e: any) => e.id === empId);
  if (emp && !this.arrOriginalAssets?.some((a: any) => a.userId === emp.id)) {
    
    const matchedAsset = this.AllAssetListingData.find(asset => asset.assetName === this.selectedAsset);
    
    const assetId = matchedAsset.assetId;
 
    
    
    this.arrOriginalAssets.push({
      id: '',
      employeeName: emp.itemName,
      employeeComment: '',
      employeeAssetStatus: 'Asset Given',
      allocatingAuthorityName: '',
      authorityName: this.arrAllocatingDept[this.selectedAsset].authorityName,
      authorityDepartment: this.arrAllocatingDept[this.selectedAsset].authorityDepartment,
      employeeEmail: '',
      authorityEmail: '',
      assetName: this.selectedAsset,
      band: emp.band,
      userId: emp.id,
      assetId: assetId,
      dateOfAllocation: new Date().toISOString(),
      currentAssetDescription: '',
      authorityCommentDate:  new Date().toISOString(),
      authorityDepartmentComment: ''
    });
  }
}

onSelectSingleEmp(event: any) {
  // Sirf current dropdown selection dikhana hai
  this.arrOriginalAssets = [];

  // Multi-select dropdown ka selected list use karo
  const selectedEmployees = this.dropDownForEmployee.filter((emp: any) =>
    this.selectedEmployee.some((sel: any) => sel.id === emp.id)
  );

  selectedEmployees.forEach((emp: any) => {
    this.addEmployeeToAssetList(emp.id);
  });

  this.allocatedAssetsList = this.arrOriginalAssets;
}


onDeSelectSingleEmp(event: any) {
  this.arrOriginalAssets = this.arrOriginalAssets.filter((a: any) => a.userId !== event.id);
  this.allocatedAssetsList = this.arrOriginalAssets;
}



  selectAllEmp(event: any) {
    this.arrOriginalAssets = [];
    event.forEach((emp: any) => this.addEmployeeToAssetList(emp.id));
  this.allocatedAssetsList = this.arrOriginalAssets;

  }


 
  onDeSelectAllEmpForReport(event: any) {
    this.arrOriginalAssets = [];
    this.allocatedAssetsList = this.arrOriginalAssets;
  }
  
 

  assetManagementHeader = [
    { label: 'Asset', isMandatory: true, sortingName: 'asset' },
    { label: 'Employee Name', isMandatory: true, sortingName: 'employeeName' },
    { label: 'Band', isMandatory: true, sortingName: 'band' },
    { label: 'Allocating Dept', isMandatory: true, sortingName: 'allocatingAuthorityDept' },
    { label: 'Authority Name', isMandatory: true, sortingName: 'allocatingAuthorityName' },
    { label: 'Date Of Allocation', isMandatory: true, sortingName: 'reimbursementType' },
    { label: 'Current Asset Description', isMandatory: true, sortingName: 'currentAssetDescription' },
   
    { label: 'HR ADMIN/Allocating Authority Comment', isMandatory: true, sortingName: 'reimbursementLimit' },
    { label: 'Authority Comment Date', isMandatory: true, sortingName: 'actualAmount' },


  ];


  allocatedAssetsList: any[] = [];

  assetAllocateEmployees() {
    
    }


    AllAssetListingData: any[] = [];
    getAllaseetListingData() {
      this.httpService.callGetService(`${this.config.getAssetListingAll}/${this.loggedInUserCompanyID}/${this.fiscalYear}/${this.year}`)
        .subscribe((elm: any) => {
          const AllAssetListingData = elm.data;
          const arrBandsForAssets:any = {};
          const arrAllocatingDept :any = {};
         
          this.AllAssetListingData = (this.findLogdinUserAsaAuthority) ? AllAssetListingData.filter((record: any) => record.userId == this.loggedInUserId) :AllAssetListingData;
          
            AllAssetListingData.map((data:any)=>{
              arrBandsForAssets[data.assetName] = data.bands;
              arrAllocatingDept[data.assetName] ={authorityName:data.authorityName,authorityDepartment:data.authorityDepartment} ;
              
            });
            this.arrBandsForAssets = arrBandsForAssets;
            this.arrAllocatingDept = arrAllocatingDept;
            
            console.log(' ------------------------------------------------- ', AllAssetListingData);
        })
  
    }
    
    getAllEmployeeRecord() {
    
    const band = this.selectedBand.map((elm: any) => elm.band);
    this.arrOriginalAssets = this.arrOriginalAssets?.filter((emp: { band: any; }) => band.includes(emp.band)) || [];

    if (!band.length) {
      this.arrOriginalAssets = [];
      this.dropDownForEmployee = [];
      
      this.userListDataForAsset = { users: [] };
      return;
    }
    const today = new Date().toISOString().split('T')[0];
    const year = this.year.split('-')[0];

    const formData = {
      companyId: this.loggedInUserCompanyID,
      bands: band,
      from: today,
      to: today,
      fromYear: year,
      toYear: year,
    };

    this.httpService.callPostService(`${this.config.getAllEmployeeListAgainstBand}`, formData)
      .subscribe((elm: any) => {

        const arrOriginalAssets = elm.data;
        
        
        arrOriginalAssets.map((asset: any) => {
          this.arrOriginalAssets?.push({
            id: '',
            employeeName: asset.firstName + asset.lastName,
            employeeComment: '',
            employeeAssetStatus: '',
            allocatingAuthorityName: '',
            employeeEmail: asset.officialEmail,
            authorityEmail: '',
            assetName: '',
            band: asset.band,
            userId: asset.id,
            assetId: '',
            dateOfAllocation: new Date().toISOString(),
            currentAssetDescription: '',
            authorityCommentDate: '',
            authorityDepartmentComment: ''
          });
        })


        
        this.dropDownForEmployee = elm.data.map((user: any) => ({
          userId: user.id,
          employeName: user.firstName + user.lastName,
          userBand: user.band,
          enableCheckAll: this.updateData
            ? this.onSelectSingleSelectFilter === user.band
              ? false
              : true
            : true,
          allowSearchFilter: this.updateData
            ? this.onSelectSingleSelectFilter === user.band
              ? false
              : true
            : true,
          disabled: this.updateData
            ? this.onSelectSingleSelectFilter === user.band
              ? false
              : true
            : false,
        }));



      

    
        
        
      });
  }


  
  cancelData() {
    this.dialogRef.close();
  }


  // ===================Save the data=============================================================
  
 
  allocateEmployees() {
 
  }

  toastShown = false;

  checkMaxLength(comment: string) {
    if (comment?.length === 255 && !this.toastShown) {
      this.toastShown = true;

      this.toastr.error('Maximum limit is 255 characters', 'Limit Reached');

      setTimeout(() => {
        this.toastShown = false;
      }, 3000); // Reset after 3s so it can show again next time
    }
  }



  saveData() {
    if (this.allocatedAssetsList.length > 0) {
      this.allocatedAssetsList.forEach((data: any, index: number) => {
        const formData = {
          companyId: this.loggedInUserCompanyID,
          assetAuthorityId: data.assetAuthorityId,
          assetId: data.assetId,
          employeeIds: [data.userId],
          dateOfAllocation: data.dateOfAllocation,
          currentAssetDescription: data.currentAssetDescription
        };
     
        this.httpService.callPostService(`${this.config.allocateEmployee}`, formData)
          .subscribe((elm: any) => {
  
            // Only show the popup after the last item is saved
            if (index === this.allocatedAssetsList.length - 1) {
              const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
                disableClose: true,
                height: '25%',
                width: '30%',
                data: {
                  msg: elm.message, // using message returned from backend
                  btn2: 'OK',
                  btn2BgColor: this.buttonColorName,
                  showSuccessIcon: true,
                  showSuccessMessage: false,
                  showCloseIcon: false
                }
              });
  
              dialogRef.afterClosed().subscribe(() => {
                this.dialogRef.close(); // Close the parent dialog if needed
              });
            }
          });
      });
    }
  }
  


}
  interface Asset {
    assetName: string;
    id: any
  
    currentAssetDescription: string;
    authorityDepartmentComment: string;
    dateOfAllocation: string,
    authorityCommentDate: string | null;  // Changed from dateOfAllocation to authorityCommentDate
  }


  







 
 

